import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function MobileMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <>
            <button
                className={`burger-button ${isOpen ? 'open' : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle menu"
                title="Navigation Menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {isOpen && (
                <div className="menu-overlay" onClick={closeMenu}></div>
            )}

            <nav className={`mobile-menu ${isOpen ? 'open' : ''}`}>
                <div className="mobile-menu-header">
                    <h3>Navigation</h3>
                    <button className="close-button" onClick={closeMenu}>×</button>
                </div>

                <div className="mobile-menu-content">
                    <Link
                        to="/"
                        className={`menu-item ${location.pathname === '/' ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        🏠 Home
                    </Link>

                    <Link
                        to="/politicians"
                        className={`menu-item ${location.pathname === '/politicians' ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        🏛️ All Politicians
                    </Link>

                    <Link
                        to="/admin"
                        className={`menu-item ${location.pathname === '/admin' ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        🔧 Admin Panel
                    </Link>
                    <div className="menu-section">
                        <div className="menu-section-title">Quick Links</div>
                        <Link
                            to="/#alert"
                            className="menu-item secondary"
                            onClick={closeMenu}
                        >
                            ⚠️ Health Alerts
                        </Link>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default MobileMenu;